const oktaConfig = {
  oidc: {
    clientId: `${window.env.REACT_APP_CLIENT_ID}`,
    issuer: `${window.env.REACT_APP_ISSUER}`,
    redirectUri: `${window.env.REACT_APP_REDIRECT_URI}`,
    scopes: ["openid", "profile", "email", "offline_access"],
  },
};

export default oktaConfig;
